// Boot profiling: phase timestamps land on window.__govcrmBoot and print
// to the console once auth resolves — see reportBootPhase().
;(window as unknown as { __govcrmBoot: Record<string, number> }).__govcrmBoot = {
  moduleStart: Math.round(performance.now()),
}
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { clerkPlugin } from '@clerk/vue'
import router from './router'
import App from './App.vue'
import { isDevAuth } from './lib/auth'
import '@fontsource/source-sans-3/400.css'
import '@fontsource/source-sans-3/600.css'
import '@fontsource/source-sans-3/700.css'
import '@fontsource/jetbrains-mono/400.css'
import '@fontsource/jetbrains-mono/500.css'
import './style.css'
import { markBoot } from './lib/bootprofile'
import { installFreshness } from './lib/freshness'

markBoot('importsDone')

const app = createApp(App)

app.use(createPinia())
markBoot('piniaReady')

// VITE_AUTH_MODE=dev skips Clerk entirely (see lib/auth.ts). Otherwise the
// publishable key is mandatory — fail loudly rather than boot half-broken.
if (!isDevAuth) {
  const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY
  if (!publishableKey) {
    throw new Error(
      'VITE_CLERK_PUBLISHABLE_KEY is required (or set VITE_AUTH_MODE=dev to bypass Clerk)',
    )
  }
  app.use(clerkPlugin, {
    publishableKey,
    afterSignOutUrl: '/sign-in',
    signInUrl: '/sign-in',
    signUpUrl: '/sign-up',
  })
}

markBoot('clerkPluginInstalled')
app.use(router)
installFreshness()

app.mount('#app')
markBoot('mounted')
